import { z } from "zod";
import { COMMENT } from "./consts";

// Form validation schema — resources array drives validation. Top-level
// region/relationship fields are not required here because each resource row
// contains its own regionHeadId.
export const schema = z.object({
  [COMMENT]: z.string().optional(),
  resources: z.array(
    z.object({
      regionHeadId: z.string().nonempty("Region Head is required"),
      resourceName: z.string().optional(),
      relationshipManagerId: z.string().optional(),
      crmOpsStatus: z.enum(["Green", "Yellow", "Red"], {
        required_error: "Status is required",
      }),
      resourceId: z.string().optional(),
      comment: z.string().optional(),
      isDeleted: z.boolean().optional().default(false),
    })
  ),
});

export type FormValues = z.infer<typeof schema>;
